import { AddOnIds } from "enums";
import { isBsi } from "features/Library/Common/utils/performanceUtils";
import { useAddOnQuery } from "features/Reporting/Content/queries/useAddOnQuery";
import { useMemo } from "react";

export const useCanViewAddonsReport = (accountId: number): boolean => {
  const addOnsQuery = useAddOnQuery(accountId);
  const isBsiAccount = isBsi(accountId);

  const canViewAddOnsReport = useMemo(() => {
    if (isBsiAccount) return true;

    return (
      addOnsQuery.isFetched && !!addOnsQuery.data?.find((addOn) => addOn.id === AddOnIds.CreateAccounts)?.isEnabled
    );
  }, [addOnsQuery, isBsiAccount]);

  return canViewAddOnsReport;
};
